module.exports = __webpack_public_path__ + "img/Weapon_132.3a493673.png";